import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import { sellerUrl } from '../../../util/url';
import { FilterStoreProvider } from '../../search/searchFilterPanel/FilterStoreProvider';
import ShopContent from './ShopContent';

// ShopContent component moved to separate file './ShopContent.jsx'

/**
 * Seller shop tab component.
 */
export default function Shop({ seller, keyword }) {
    return (
        <FilterStoreProvider initialFilters={{}}>
            <section className="Shop">
                <Helmet>
                    <link rel="alternate" type="application/atom+xml" href={`${sellerUrl(seller)}/feed.atom`} />
                </Helmet>
                <ShopContent seller={seller} keyword={keyword} />
            </section>
        </FilterStoreProvider>
    );
}
Shop.propTypes = {
    seller: PropTypes.shape({
        id:  PropTypes.string.isRequired
    }).isRequired,
    keyword: PropTypes.string
};
